<ng-container *ngIf="application$ | async as app;">
    <ng-container *ngIf="isMobile$ | async">
        <div class="mobile-header">
            <div class="header-container">
                <div class="galleria">
                    <app-galleria
                        [images]="getPropertyMediaList(app)"
                    ></app-galleria>
                    <div class="header-buttons">
                        <div class="header-button">
                            <app-button
                                [buttonClass]="'only-icon-light-gray'"
                                [icon]="'assets/images/new-design-icons/Arrow Left (white).svg'"
                                [iconDirection]="'left'"
                                (buttonClick)="prevPage()"
                            ></app-button>
                        </div>
                        <div class="header-button">
                            <app-button
                                [buttonClass]="'only-icon-light-gray'"
                                [icon]="'assets/images/new-design-icons/Link (white).svg'"
                                [iconDirection]="'left'"
                                (buttonClick)="shareHandler(app.id)"
                            ></app-button>
                            <app-button
                                [buttonClass]="'only-icon-light-gray'"
                                icon="./assets/images/new-design-icons/{{ isLiked ? 'liked' : 'unliked' }}.svg"
                                [iconDirection]="'left'"
                                (buttonClick)="toggleFavorite(app.id)"
                            ></app-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="container wrapper-width">
        <ng-container *ngIf="!(isMobile$ | async); else mobileTmp">
            <div class="header">
                <div class="title-block">
                    <div class="prop-title" [innerHTML]="getPropertyTitle(app)"></div>
                    <div class="coast">{{ objectPrice | mask : 'separator.2' }} ₸</div>
                </div>
                <div class="buttons">
                    <div class="button mr-12" (click)="copyApplicationId(app.id)">
                        <img class="mr-8" src="./assets/images/new-design-icons/Copy (white).svg" loading="lazy"/>
                        Номер объекта: {{ app.id }}
                    </div>
                    <div class="button mr-12">
                        <img class="mr-8" src="./assets/images/new-design-icons/Eye (white).svg" loading="lazy"/>
                        {{ app.realPropertyDto.viewCount }} просмотров
                    </div>
                    <div class="button mr-12" (click)="shareHandler(app.id)">
                        <img src="./assets/images/new-design-icons/Link (white).svg" loading="lazy"/>
                    </div>
                    <div class="button" (click)="toggleFavorite(app.id)">
                        <img src="./assets/images/new-design-icons/{{ isLiked ? 'liked' : 'unliked' }}.svg" loading="lazy"/>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #mobileTmp>
            <div class="header mt-24">
                <div class="buttons">
                    <div class="button mr-12" (click)="copyApplicationId(app.id)">
                        <img class="mr-8" src="./assets/images/new-design-icons/Copy (white).svg" loading="lazy"/>
                        Номер объекта: {{ app.id }}
                    </div>
                </div>

                <div class="title-block mt-24">
                    <div class="prop-title">
                        <div class="prop-title" [innerHTML]="getPropertyTitle(app)"></div>
                        <div class="title-bottom">
                            <div class="coast">{{ objectPrice | mask : 'separator.2' }} ₸</div>
                            <div class="total-visible">
                                <img class="mr-8" src="./assets/images/new-design-icons/Eye (white).svg" loading="lazy"/>
                                {{ app.realPropertyDto.viewCount }} просмотров
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-24">
                <app-card-agent [totalObjects]="sameObjTotal" [agentDto]="app.agentDto" (navigateToObjects)="navigateToObjects()"></app-card-agent>
            </div>
        </ng-template>

        <div class="content">
            <ng-container *ngIf="!(isMobile$ | async)">
                <div class="top-block">
                    <div class="gallery">
                        <app-galleria
                            [gClass]="'b12'"
                            [images]="getPropertyMediaList(app)"
                        ></app-galleria>
                    </div>
                    <div class="agent-card">
                        <app-card-agent [totalObjects]="sameObjTotal" [agentDto]="app.agentDto" (navigateToObjects)="navigateToObjects()"></app-card-agent>
                    </div>
                </div>
            </ng-container>

            <div class="block">
                <div class="label label-title">Рядом</div>
                <div class="buttons">
                    <div class="button" *ngFor="let b of nearButtons;">
                        <app-button
                            [text]="b.label"
                            [icon]="b.icon"
                            [iconDirection]="'left'"
                            [buttonClass]="(selectedButtonId === b.id) ? 'small-orange' : 'small-gray'"
                            (buttonClick)="selectNear(b.id)"
                        ></app-button>
                    </div>
                </div>
                <div class="near-content" *ngIf="selectedButtonId">
                    <div class="complex-items">
                        <ng-container *ngIf="getComplexNear(app).length; else emptyTmp">
                            <div class="complex-item" *ngFor="let item of getComplexNear(app)">
                                <div class="item-left">
                                    <div class="item-title">{{ item.name }}</div>
                                    <div class="item-subtitle">{{ item.streetName }} {{ item.number }}</div>
                                </div>
                                <div class="item-right">
                                    <img src="assets/images/new-design-icons/Star (orange).svg"/>
                                    <span>{{ item.rating | number : '1.1-2' }}</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #emptyTmp>
                            <div style="color: white">Отсутствует</div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="block">
                <div class="label label-title">Описание</div>
                <div class="description" [style.max-height]="moreDescriptionText ? 'none' : '4rem'">
                    {{ app.sellDataDto.description }}
                </div>
                <div class="more-button" (click)="moreDescriptionText = !moreDescriptionText" *ngIf="app.sellDataDto.description">{{ moreDescriptionText ? 'Показать меньше' : 'Показать больше' }}</div>
            </div>

            <div class="block">
                <div class="links">
                    <div class="link-card">
                        <div class="info">
                            <div class="title">Записаться на</div>
                            <div class="subject">показ</div>
                            <div class="description">Теперь можете заранее записаться в удобное для вас время</div>
                        </div>
                        <div class="button">
                            <app-button
                                    [text]="'Перейти'"
                                    [buttonClass]="'big-light-gray'"
                                    (buttonClick)="openShowingModal = true"
                                    [buttonId]="'CLICK_SIGN_UP_SHOW_APARTMENT'"
                            ></app-button>
                        </div>
                    </div>

<!--                    <div class="link-card">-->
<!--                        <div class="info">-->
<!--                            <div class="title">Забронировать</div>-->
<!--                            <div class="subject">обьект</div>-->
<!--                            <div class="description">Забронируйте эту квартиру прямо сейчас, чтобы купить ее в 3 шага</div>-->
<!--                        </div>-->
<!--                        <div class="button">-->
<!--                            <app-button-->
<!--                                    [text]="'Перейти'"-->
<!--                                    [buttonClass]="'big-light-gray'"-->
<!--                                    (buttonClick)="openContractPanel = true"-->
<!--                                    [buttonId]="'CLICK_BOOK_OBJECT_APARTMENT'"-->
<!--                            ></app-button>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="link-card">-->
<!--                        <div class="info">-->
<!--                            <div class="title">Ипотека за</div>-->
<!--                            <div class="subject">3 дня</div>-->
<!--                            <div class="description">Заполните ваши данные и запишитесь к нам на консультацию для подбора лучшей ипотечной программы</div>-->
<!--                        </div>-->
<!--                        <div class="button">-->
<!--                            <app-button-->
<!--                                    [text]="'Перейти'"-->
<!--                                    [buttonClass]="'big-light-gray'"-->
<!--                                    (buttonClick)="openMortgageModal = true"-->
<!--                                    [buttonId]="'CLICK_MORTGAGE_TREE_DAYS'"-->
<!--                            ></app-button>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>

            <div class="block">
                <div class="label label-title">Общая информация</div>
                <div class="content">
                    <div class="items-line" [style.max-height]="showMoreInfo ? ((isMobile$ | async) ? '100%' : '400px') : '265px'">
                        <ng-container *ngFor="let line of getRealPropertyInfo(app); let i = index">
                            <ng-container *ngIf="line.value">
                                <div class="line" *ngIf="line && i <= 11">
                                    <div class="title">{{ line.label }}</div>
                                    <div class="value">{{ line.value }} <span *ngIf="i === 2">м<sup><small>2</small></sup></span></div>
                                </div>
                                <div class="line" *ngIf="showMoreInfo && line && i > 11">
                                    <div class="title">{{ line.label }}</div>
                                    <div class="value">{{ line.value }}</div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="more-button" *ngIf="getRealPropertyInfo(app).length > 12" (click)="showMoreInfo = !showMoreInfo">Показать {{ showMoreInfo ? 'меньше' : 'больше' }}</div>
            </div>

            <div class="block">
                <div class="label label-title">На карте</div>
                <app-map [coordinateCenter]="coordinatesOfObject(app)" [price]="app.sellDataDto.objectPrice"></app-map>
            </div>

            <div class="block">
                <app-calculator [objectPrice]="objectPrice"></app-calculator>
            </div>

            <div class="block" #objectList>
                <app-object-list
                        [header]="'Похожие объекты'"
                        [totalCount]="sameObjTotal"
                        [items]="sameRealPropertyList"
                        (getMore)="getSameRealProperty(app, true)"
                ></app-object-list>
            </div>

        </div>
<!--        <ng-template #showingModal>-->
<!--            <app-sign-up-showing [appId]="app.id" *ngIf="openShowingModal" (closeEvent)="openShowingModal = $event"></app-sign-up-showing>-->
<!--        </ng-template>-->
<!--        <app-panel [visible]="openShowingModal" (visibleChange)="openShowingModal = $event" [template]="showingModal"></app-panel>-->
<!--        <ng-template #contractModal>-->
<!--            <app-create-contract [appId]="app.id" *ngIf="openContractPanel" (closeEvent)="openContractPanel = $event"></app-create-contract>-->
<!--        </ng-template>-->
<!--        <app-panel [visible]="openContractPanel" (visibleChange)="openContractPanel = $event" [header]="'Ознакомтесь с правилами'" [template]="contractModal"></app-panel>-->

<!--        <ng-template #mortgageModal>-->
<!--            <app-mortgage [appId]="app.id" *ngIf="openMortgageModal" (closeEvent)="openMortgageModal = $event"></app-mortgage>-->
<!--        </ng-template>-->
<!--        <app-panel [visible]="openMortgageModal" (visibleChange)="openMortgageModal = $event" [header]="'Ипотека за 3 дня'" [template]="mortgageModal"></app-panel>-->
        <app-apply-application *ngIf="openShowingModal" (visiblePanelChange)="openShowingModal = $event"></app-apply-application>
    </div>
</ng-container>
